<script>
  export let quotes;
  export let gettingQuote;
</script>

<style>
  div {
    text-align: center;
    position: relative;
    max-width: 50vw;
  }

  p {
    font-size: 4vh;
    filter: drop-shadow(-5px 5px 5px rgba(0, 0, 0, 0.8));
    animation: quote 700ms linear;
  }

  @keyframes quote {
    from {
      transform: scale(0.7);
      opacity: 0.2;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }
</style>

<div>
  {#each quotes as { content, author }}
    <p class="quote">
      {content}
      <br />
      - {author}
    </p>
  {/each}

  {#if gettingQuote}
    <p>Getting Quote...</p>
  {/if}
</div>
